import styled, { css, keyframes } from 'styled-components'
import { RADII } from 'styles/consts'
import ModelDropdown from './OptionDropdown/ModelDropdown'

export const ModelSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  gap: 12px;
`

export const ModelOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;

  .quality-dropdown {
    flex-basis: 46%;
  }
  .option-dropdown {
    width: auto;
    flex-grow: 1;
    min-width: 0;
  }
`

const ripple = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(20, 20, 43, 0.5);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(20, 20, 43, 0);
  }
`

export const VideoModelDropdownWrapper = styled.div<{ $pulse: boolean }>`
  position: relative;
  border-radius: ${RADII.field};
  ${({ $pulse }) =>
    $pulse &&
    css`
      animation: ${ripple} 1.8s ease-out infinite;
    `}
`

export const VideoModelDropdown = styled(ModelDropdown)`
  height: 40px;
`
